/**
 * configurationSettingsSlice — Configuration settings (Email / WhatsApp / SMS).
 *
 * Hydrated from the design seed via ConfigurationSettingsInitializer; the form
 * seeds its local state from here and dispatches `setConfigurationSettings` on
 * save. No backend endpoint yet — when the email-configuration API lands, swap
 * the seed for a real SSR fetcher (the slice shape stays the same).
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  type ConfigurationSettings,
  defaultConfigurationSettings,
} from "@/components/settings/configuration/types";

export interface ConfigurationSettingsState {
  settings: ConfigurationSettings;
  loading: boolean;
}

const initialState: ConfigurationSettingsState = {
  settings: defaultConfigurationSettings(),
  loading: true,
};

const configurationSettingsSlice = createSlice({
  name: "configurationSettings",
  initialState,
  reducers: {
    /** Replace the configuration settings — used to hydrate on mount. */
    setConfigurationSettings(
      state,
      action: PayloadAction<ConfigurationSettings>,
    ) {
      state.settings = action.payload;
    },
    setConfigurationLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setConfigurationSettings, setConfigurationLoading } =
  configurationSettingsSlice.actions;

export default configurationSettingsSlice.reducer;
